import { ISideNavigation } from '@/components/ui/side-navigation/types';
import { Roles } from '@/core/types';
import {
	ACCOUNT_ADMIN_NAVIGATION_ITEMS,
	LEVIANT_ADMIN_NAVIGATION_ITEMS,
	OPERATOR_NAVIGATION_ITEMS,
	SITE_ADMIN_NAVIGATION_ITEMS,
	SITE_SUPERVISOR_NAVIGATION_ITEMS,
} from './navigation';
import {
	ACCOUNT_ADMIN_HIERARCHY,
	LEVIANT_ADMIN_HIERARCHY,
	OPERATOR_HIERARCHY,
	SITE_ADMIN_HIERARCHY,
	SITE_SUPERVISOR_HIERARCHY,
} from './roles.hierarchy';

interface RoleConfig {
	indexRoute: string;
	navigationItems: ISideNavigation;
	hierarchy: Roles[];
}

export default {
	[Roles.LEVIANT_ADMIN]: {
		indexRoute: '/dashboard',
		navigationItems: LEVIANT_ADMIN_NAVIGATION_ITEMS,
		hierarchy: LEVIANT_ADMIN_HIERARCHY,
	},
	[Roles.ACCOUNT_ADMIN]: {
		indexRoute: '/dashboard',
		navigationItems: ACCOUNT_ADMIN_NAVIGATION_ITEMS,
		hierarchy: ACCOUNT_ADMIN_HIERARCHY,
	},
	[Roles.SITE_ADMIN]: {
		indexRoute: '/dashboard',
		navigationItems: SITE_ADMIN_NAVIGATION_ITEMS,
		hierarchy: SITE_ADMIN_HIERARCHY,
	},
	[Roles.SITE_SUPERVISOR]: {
		indexRoute: '/dashboard',
		navigationItems: SITE_SUPERVISOR_NAVIGATION_ITEMS,
		hierarchy: SITE_SUPERVISOR_HIERARCHY,
	},
	[Roles.OPERATOR]: {
		indexRoute: '/dashboard',
		navigationItems: OPERATOR_NAVIGATION_ITEMS,
		hierarchy: OPERATOR_HIERARCHY,
	},
} as Record<Roles, RoleConfig>;
